// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"H4-z","colorTextValue":"I4-z","swatches":"J4-z","collapseLink":"K4-z","isCollapsed":"L4-z","dropdown":"M4-z","disabled":"N4-z"};